function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import BigNumber from "bignumber.js";
export function numberToDelimited(input, options) {
  var numeric = new BigNumber(input);

  if (!numeric.isFinite()) {
    return input.toString();
  }

  if (!options.delimiterPattern.global) {
    throw new Error("options.delimiterPattern must be a global regular expression; received ".concat(options.delimiterPattern));
  }

  var _numeric$toString$spl = numeric.toString().split("."),
      _numeric$toString$spl2 = _slicedToArray(_numeric$toString$spl, 2),
      left = _numeric$toString$spl2[0],
      right = _numeric$toString$spl2[1];

  left = left.replace(options.delimiterPattern, function (digitToDelimiter) {
    return "".concat(digitToDelimiter).concat(options.delimiter);
  });
  return [left, right].filter(Boolean).join(options.separator);
}